import {
  Box,
  Button,
  Flex,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
  useToast,
} from '@chakra-ui/react';
import React from 'react';
import { Formik, Form } from 'formik';
import TableRow from '../../../../components/InverterTableRow';
import { useCustomMutation } from '../../../../hooks/useCustomMutation';
import axiosInstance from '../../../../services/api';

const StepOne = ({ onClose, handleNext, setResponceData }) => {
  const toast = useToast();
  const { mutate, isLoading } = useCustomMutation(axiosInstance);

  const initialValues = [
    {
      item: 'Light Bulbs',
      quantity: 0,
      wattage: '',
    },
    {
      item: 'TV',
      quantity: 0,
      wattage: '',
    },
    {
      item: 'Phones',
      quantity: 0,
      wattage: '',
    },
    {
      item: 'Laptops',
      quantity: 0,
      wattage: '',
    },
    {
      item: 'Decoder',
      quantity: 0,
      wattage: '',
    },
    {
      item: 'Freezer',
      quantity: 0,
      wattage: '',
    },
    {
      item: 'Blender',
      quantity: 0,
      wattage: '',
    },
    {
      item: 'Iron or Microwave',
      quantity: 0,
      wattage: '',
    },
    {
      item: 'Juice Mixer/Grinder',
      quantity: 0,
      wattage: '',
    },
    {
      item: 'Air Conditioner',
      quantity: 0,
      wattage: '',
    },
    {
      item: 'Gaming Console',
      quantity: 0,
      wattage: '',
    },
    {
      item: 'Music System',
      quantity: 0,
      wattage: '',
    },
  ];

  const handleSubmit = (values, { resetForm, setSubmitting }) => {
    // Filter items with valid quantity and wattage
    const validItems = values.filter(({ item, quantity, wattage }) => {
      return quantity !== 0 && wattage !== '';
    });

    if (validItems.length === 0) {
      // Show a toast message if no valid items
      toast({
        title: `Fill in quantity and wattage for selected item to proceed.`,
        status: 'info',
      });
      return;
    }

    const payload = validItems.map(({ item, quantity, wattage }) => ({
      item,
      quantity: quantity.toString(),
      wattage: wattage.toString(),
    }));

    // console.log('Calculator Payload: ', JSON.stringify(payload, null, 2));

    if (payload) {
      mutate({
        url: `/Customers/customerinvertercalculation`,
        data: payload,
        method: 'POST',
        onSuccess: (data) => {
          // console.log('Success:', data);
          if (data.responseCode === '00') {
            // console.log(
            //   'Calculator Response: ',
            //   JSON.stringify(data?.data[0], null, 2)
            // );
            setResponceData(data?.data);
            toast({
              title: `${data?.responseMessage}`,
              status: 'success',
            });
            handleNext();
            resetForm();
            setSubmitting(false);
          } else {
            toast({
              title: `${data?.responseMessage}`,
              status: 'error',
            });
          }
        },
        onError: (error) => {
          // console.log('Error:', error);
          toast({
            title: `${error?.response?.statusText}`,
            status: 'error',
          });
        },
      });
    } else {
      toast({
        title: `Fill the items with appropraite values to proceed`,
        status: 'info',
      });
    }
  };

  return (
    <>
      {isLoading ? (
        <VStack spacing={16} mt={24}>
          <Spinner
            size={'xl'}
            thickness='10px'
            color='orange'
            width='200px'
            height='200px'
          />
          <Box textAlign={'center'}>
            <Text fontSize={'20px'} fontWeight={600} mb={4}>
              Please wait
            </Text>
            <Text fontSize={'14px'}>While we calculate your load capacity</Text>
          </Box>
          <Button
            w={'60%'}
            mt='16'
            onClick={onClose}
            border='1px solid #E53511'
            py={6}
            px={20}
            color={'#E53511'}
          >
            Cancel
          </Button>
        </VStack>
      ) : (
        <Box>
          <Text fontSize={'12px'} color={'brand.10'}>
            Ever wondered about the optimal Inverter capacity needed for your
            home?
          </Text>
          <Text fontSize={'14px'} lineHeight={1.2} mt={1}>
            Our easy to use "Power Consumption Calculator" will help you to know
            the exact total load requirements for your property!
          </Text>
          <>
            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
              {({ values, handleChange, setFieldValue, resetForm }) => (
                <Form>
                  <TableContainer pt={5}>
                    <Table variant='simple' size='sm'>
                      <Thead>
                        <Tr>
                          <Th> </Th>
                          <Th py={3}>Wattage</Th>
                          <Th py={3}>Quantity</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {values.map((itemData, index) => (
                          <TableRow
                            key={index}
                            title={itemData.item}
                            wattage={itemData.wattage}
                            onWattageChange={handleChange(`${index}.wattage`)}
                            quantity={itemData.quantity}
                            onQuantityDecrement={() =>
                              setFieldValue(
                                `[${index}].quantity`,
                                Math.max(itemData.quantity - 1, 0)
                              )
                            }
                            onQuantityIncrement={() =>
                              setFieldValue(
                                `[${index}].quantity`,
                                itemData.quantity + 1
                              )
                            }
                            setFieldValue={setFieldValue} // Pass setFieldValue
                          />
                        ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                  <Flex>
                    <Button
                      type='submit'
                      fontSize={'14px'}
                      mt='4'
                      mr={4}
                      border='1px solid #32C36C'
                      py={6}
                      px={20}
                      colorScheme='green'
                    >
                      Calculate
                    </Button>
                    <Button
                      mt='4'
                      onClick={resetForm}
                      border='1px solid #32C36C'
                      py={6}
                      px={20}
                      color={'brand.10'}
                    >
                      Reset
                    </Button>
                  </Flex>
                </Form>
              )}
            </Formik>
          </>
        </Box>
      )}
    </>
  );
};

export default StepOne;
